import { workingStatus } from '@/api/common/master-lists'

const data = {
  items: sessionStorage.getItem('workingStatuses')
    ? JSON.parse(sessionStorage.getItem('workingStatuses'))
    : [],
  selected: null,
  saved: false
}

export default {
  namespaced: true,

  state () {
    return {
      ...data
    }
  },
  mutations: {

    /**
     * Set the items.
     *
     * @param {*} state
     * @param {*} items
     */
    SET_ITEMS (state, items) {
      state.items = items
    },

    /**
     * Set the saved state.
     *
     * @param {*} state
     * @param {*} saved
     */
    SET_SAVED (state, saved) {
      state.saved = saved
    },

    /**
     * Set the items.
     *
     * @param {*} state
     * @param {*} selected
     */
    SET_SELECTED (state, selected) {
      state.selected = selected
    },

    /**
     * Reset the state to default.
     *
     * @param {*} state
     */
    RESET (state) {
      for (const key in state) {
        state[key] = data[key]
      }
    }
  },
  actions: {

    /**
     * Get all work status records
     */
    all ({ commit, dispatch, state }) {
      if (state.items.length) return

      return workingStatus.index()
        .then(({ data }) => {
          commit('SET_ITEMS', data)

          sessionStorage.setItem('workingStatuses', JSON.stringify(data))
        })
        .catch(({ response }) => dispatch('httpException/handle', response, { root: true }))
    },

    /**
     * Set the saved state
     *
     * @param {*} param0
     * @param {*} saved
     */
    setSaved ({ commit }, saved) {
      commit('SET_SAVED', saved)
    },

    /**
     * Set item in selected state
     *
     * @param {*} param0
     * @param {*} item
     */
    setSelectedItem ({ commit, state }, item) {
      commit('SET_SELECTED', item)
    }
  }
}
